import React, { useEffect, useState } from 'react';

import apiService from '../services/api';
import { useAuth } from '../auth/AuthContext';
import { StoreUser } from '../types';
import GetSkillCelebration from './GetSkillCelebration';
import useGetSkillCelebration from '../hooks/useGetSkillCelebration';

/**
 * GET SKILL お祝い演出のアプリ全体マウント（設計書 §6.3 p.21）。
 *
 * 従来はマイページを開いた時だけ表示していたが、ワーカーが気づけないため、
 * どの画面を開いても未読スキルがあれば表示するよう App 直下へ移設（修正依頼 #48）。
 * 「1回だけ表示」の冪等性（localStorage + seen_at）は useGetSkillCelebration が担保する。
 *
 * 課題87で GetSkillCelebration は画面遷移しない「閉じるのみ」のオーバーレイポップアップに変更済み。
 * 開いている画面（求人詳細など）の上に重ねて表示するため App 直下にマウントしている。
 */
const GlobalGetSkillCelebration: React.FC = () => {
  const { userId, isAuthenticated } = useAuth();
  const [storeUserIds, setStoreUserIds] = useState<string[]>([]);

  useEffect(() => {
    let cancelled = false;
    const run = async () => {
      if (!isAuthenticated || !userId) return;
      const res = await apiService.getStoreUser(userId);
      if (cancelled) return;
      if (res?.success && res.data) {
        setStoreUserIds(res.data.map((su: StoreUser) => su.id));
      }
    };
    run();
    return () => {
      cancelled = true;
    };
  }, [userId, isAuthenticated]);

  const { celebrationSkills, closeCelebration } = useGetSkillCelebration(storeUserIds);

  return <GetSkillCelebration skills={celebrationSkills} onClose={closeCelebration} />;
};

export default GlobalGetSkillCelebration;
